import * as Sentry from "@sentry/react";

const isProd = process.env.NODE_ENV === "production";

Sentry.init({
    dsn: "https://db662298ad88eb232f931a1dc8f07171@o4511699069960192.ingest.de.sentry.io/4511699075661904",
    environment: isProd ? "production" : "development",
    integrations: [
        Sentry.browserTracingIntegration()
    ],
    tracesSampleRate: isProd ? 0.2 : 1.0,

    tracePropagationTargets: ["localhost", /^https:\/\/carskaut\.com/],

    enableLogs: isProd,
});